import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';
import type { FromPMHandlers } from '../types';
import { convertBlockChildren } from '../utils';

function getChecked(node: PMNode): boolean | null {
	const attrs = node.attrs;
	// Support both `checked` attr (standard) and `state` attr (ADF taskItem)
	if (attrs.checked === true) {
		return true;
	}
	if (attrs.checked === false) {
		return false;
	}
	if (attrs.state === 'DONE') {
		return true;
	}
	if (attrs.state === 'TODO') {
		return false;
	}
	return null;
}

// convertTaskItem handles both regular list items (checked: null) and task items
// (checked: true/false) via getChecked, so convertListItem is not needed separately.
export function convertTaskItem(
	node: PMNode,
	handlers: FromPMHandlers,
): {
	checked: boolean | null;
	children: ReturnType<typeof convertBlockChildren>;
	spread: false;
	type: 'listItem';
} {
	const checked: boolean | null = getChecked(node);
	const children: ReturnType<typeof convertBlockChildren> = convertBlockChildren(node, handlers);
	return {
		type: 'listItem' as const,
		spread: false,
		checked,
		children,
	};
}
